import { render } from "./_base-radio.vue?vue&type=template&id=12998561"
import script from "./_base-radio.vue?vue&type=script&lang=js"
export * from "./_base-radio.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./_base-radio.vue?vue&type=style&index=0&id=12998561&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__